import {
  MarketingCommunityEvent,
  MarketingEventID,
} from '../airtable/marketing.types';
import {
  getLocalMarketingEvents,
  getServerMarketingEvents,
} from '../ruleset/airtable';
import { State } from '../State';
/**
 * Return marketing event by id
 */
export function getMarketingEventById(
  id: string,
): MarketingCommunityEvent | undefined {
  const byID = (event: MarketingCommunityEvent) =>
    event.id === (id as MarketingEventID);

  return (
    getServerMarketingEvents().find(byID) ||
    getLocalMarketingEvents().find(byID)
  );
}

/**
 * Check if marketing event is finished
 */
export function isMarketingEventFinished(
  id: MarketingEventID,
  now: number,
): boolean {
  const event = getMarketingEventById(id);
  // This id not exist in our config let's assume it was deleted and this mean that event is finished
  if (!event) return true;

  // Check event end time
  const endTime = event.duration
    ? new Date(event.date).getTime() + event.duration
    : Infinity;
  const isFinished = now >= endTime;

  // Is event finished
  if (!isFinished) {
    return false;
  }

  // Detect if event is last
  const localEvents = getLocalMarketingEvents();
  const serverEvents = getServerMarketingEvents();
  const lastEventServer = serverEvents[serverEvents.length - 1];
  const lastEventLocal = localEvents[localEvents.length - 1];
  const isLast = (lastEvent: MarketingCommunityEvent | undefined) =>
    lastEvent?.date === event.date && lastEvent?.id === event.id;

  // Last event never expires
  if (isLast(lastEventServer) || isLast(lastEventLocal)) {
    return false;
  }

  // Event is finished
  return true;
}

/**
 * Is marketing reward consumed
 */
export function isMarketingEventConsumed(
  state: State,
  id: MarketingEventID,
): boolean {
  return !!state.marketing[id];
}

/**
 * Return expired marketing ids
 */
export function getExpiredMarketingIds(
  state: State,
  now: number,
): MarketingEventID[] {
  const expired = [];

  for (const id in state.marketing) {
    if (isMarketingEventFinished(id, now)) {
      expired.push(id);
    }
  }

  return expired;
}

/**
 * Exclude chest rewards for users on first level
 */
export function getMarketingRewards(event: MarketingCommunityEvent) {
  return event.rewards;
}
